import { render, staticRenderFns } from "./Contenedor.vue?vue&type=template&id=d60b7a56&scoped=true"
import script from "./Contenedor.vue?vue&type=script&lang=js"
export * from "./Contenedor.vue?vue&type=script&lang=js"
import style0 from "./Contenedor.vue?vue&type=style&index=0&id=d60b7a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60b7a56",
  null
  
)

export default component.exports